import { useSelector } from 'react-redux';
import { readStates } from '@/constants/lifecycle';
import findResult from '@/utils/resultsHelper';
import { workspaceForms } from '@/workspaces/constants';
import { workspaceFormSections } from '@/workspaces/state/state';
import { datasetConditionsStatus } from '@/datasets/status/helper';
import requestWorkspaceLocation from '../helper';
import { requestSources } from '../../constants';
import { newRequest, requestActionsState, resolveRequestWorkflow } from '../../state/state';

const useRequestWorkspaceInfo = ({ category, code }) => useSelector(({
  requests: { requests },
  workflows: { workflows },
  workspaces: { forms },
}) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, { category, code });
  const item = findResult(forms, 'open', workspaceForms.REQUEST) || { ...workspaceFormSections(), ...readStates };

  return {
    fields: item.sections.workspace.fields,
    name: request.request_source === requestSources.COHORT ? source.name : source.catalogue?.title,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    request,
    saveErrors: request.saveErrors,
    saveStatus: request.saveStatus,
    sourceCode: source.code,
    sourceType: request.request_source,
    values: request.fields,
  };
});

const useSelectWorkspaces = ({ category, code }) => useSelector(({
  requests: { requests },
  workflows: { workflows },
}) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, { category, code }, newRequest({ code }));
  const { workspaces } = request.steps;
  const safeSource = source || { code: null };

  return {
    ...requestWorkspaceLocation(request),
    ...datasetConditionsStatus(safeSource),
    entity: request.request_source,
    name: request.request_source === requestSources.COHORT ? safeSource.name : safeSource.catalogue?.title,
    readStatus: workspaces.readStatus,
    sourceCode: safeSource.code,
    workspaces: workspaces.results,
  };
});

const useRequestWorkspaceActions = ({ category, code }) => useSelector(({
  requests: { requests },
  workflows: { workflows },
  workspaces: { locations, forms },
}) => {
  const {
    form, steps, readErrors, saveStatus,
  } = requestActionsState({ category, code }, requests, workflows, locations, forms);
  const { sourceUrl } = steps;

  return {
    readErrors,
    requestNewWorkspaceReadStatus: form.readStatus,
    saveStatus,
    sourceUrl,
  };
});

export default {
  useRequestWorkspaceActions,
  useRequestWorkspaceInfo,
  useSelectWorkspaces,
};
